import { render, staticRenderFns } from "./ModifyAdditionalShares.vue?vue&type=template&id=43d4ed98&"
import script from "./ModifyAdditionalShares.vue?vue&type=script&lang=js&"
export * from "./ModifyAdditionalShares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports